
import { jsPDF } from "jspdf";

export const addHeaderToPage = (pdf: jsPDF, pageWidth: number, margin: number) => {
  // Add white header with shadow effect - reduced height
  pdf.setFillColor(255, 255, 255);
  pdf.rect(0, 0, pageWidth, 35, 'F');
  
  // Add subtle shadow line
  pdf.setDrawColor(155, 135, 245);
  pdf.setFillColor(155, 135, 245, 0.1);
  pdf.rect(0, 35, pageWidth, 1, 'F');

  // Add decorative corners
  const cornerSize = 8;
  pdf.setDrawColor(155, 135, 245, 0.3);
  // Top left corner
  pdf.line(margin, margin, margin + cornerSize, margin);
  pdf.line(margin, margin, margin, margin + cornerSize);
  // Top right corner
  pdf.line(pageWidth - margin - cornerSize, margin, pageWidth - margin, margin);
  pdf.line(pageWidth - margin, margin, pageWidth - margin, margin + cornerSize);

  // Add logo with smaller size
  const logoImg = new Image();
  logoImg.src = "/lovable-uploads/8a7563bc-58a9-4c76-bab1-8a146b858908.png";
  pdf.addImage(logoImg, 'PNG', margin, 5, 25, 25);

  return 40;
};
